<template>
  <div
    class="relative mobile:block mobile:text-center tablet:flex items-center justify-between shadow-[0px_0px_10px_-3px_#00000057] rounded-lg z-10 px-3 py-2 mt-4 bg-white">
    <p class="select-none tablet:mb-0 mobile:mb-2 text-[#999999]">
      Copyright © {{currentYear}} fyxify Home Services LLC.
    </p>
    <ul class="list-inline mb-0 flex items-center mobile:justify-center">
      <!-- <li class="px-3 border-r border-gray-300">
        <a href="https://fyxify.pro/solutions-contractors/" target="_blank"
          class="select-none text-base no-underline text-purple-400">Useful Tips</a>
      </li>
      <li class="px-3">
        <a href="https://fyxify.pro/about-us/" target="_blank"
          class="select-none text-base no-underline text-purple-400">How fyxify
          works</a>
      </li> -->
    </ul>
  </div>
</template>

<script>
export default {
   data() {
        return {
          currentYear: new Date().getFullYear(),
        }}
  // name: "FooterPartial",
};
</script>